/* ==========================================================================
   NaturoTheke — Unterkategorien: Reihe zum Wischen

   Dawns slider-component rechnet ihren Schritt aus ihrem eigenen Raster
   (grid--N-col-desktop). Mit unseren Kacheln kam sie auf 141 statt 281 Pixel
   und sprang mitten in eine Karte, das Ende wurde nie erreicht. Deshalb hier
   eine eigene, kurze Mechanik: Sie springt um ganze sichtbare Karten weiter
   und blendet den Pfeil aus, wenn es in diese Richtung nichts mehr gibt.
   ========================================================================== */

(function () {
  'use strict';

  if (!window.customElements || customElements.get('naturo-subcollections')) return;

  customElements.define(
    'naturo-subcollections',
    class NaturoSubcollections extends HTMLElement {
      connectedCallback() {
        this.reihe = this.querySelector('.nsc__row');
        this.zurueck = this.querySelector('[name="previous"]');
        this.weiter = this.querySelector('[name="next"]');
        if (!this.reihe || !this.weiter) return;

        this.punkteLeiste = this.querySelector('[data-nsc-dots]');

        this.zurueck.addEventListener('click', () => this.springe(-1));
        this.weiter.addEventListener('click', () => this.springe(1));
        this.reihe.addEventListener('scroll', () => {
          this.pfeile();
          this.punkteAktualisieren();
        });

        // Breiten aendern sich mit dem Fenster und wenn Bilder nachladen.
        if (window.ResizeObserver) {
          new ResizeObserver(() => {
            this.pfeile();
            this.punkteBauen();
          }).observe(this.reihe);
        }
        this.pfeile();
        this.punkteBauen();
      }

      /* Wie viele Karten passen nebeneinander? Entscheidet, wie viele Seiten
         es gibt — und damit die Zahl der Punkte.

         Die Luecke muss dazugerechnet werden: Vier Karten brauchen nur DREI
         Luecken, nicht vier. Ohne diese Korrektur kam die Rechnung auf drei
         sichtbare Karten statt vier und zeigte eine Seite zu viel an. */
      proSeite() {
        var karten = this.reihe.querySelectorAll('.nsc__item');
        var schritt = this.schritt();
        var breite = karten.length ? karten[0].getBoundingClientRect().width : schritt;
        var luecke = Math.max(0, schritt - breite);
        return Math.max(1, Math.floor((this.reihe.clientWidth + luecke) / schritt));
      }

      punkteBauen() {
        if (!this.punkteLeiste) return;
        var karten = this.reihe.querySelectorAll('.nsc__item').length;
        var seiten = Math.ceil(karten / this.proSeite());

        // Eine Seite heisst: es gibt nichts zu blaettern, also auch nichts
        // anzuzeigen.
        if (seiten < 2) {
          this.punkteLeiste.innerHTML = '';
          return;
        }
        if (this.punkteLeiste.children.length === seiten) {
          this.punkteAktualisieren();
          return;
        }

        this.punkteLeiste.innerHTML = '';
        for (var i = 0; i < seiten; i++) {
          var punkt = document.createElement('button');
          punkt.type = 'button';
          punkt.className = 'nsc__dot';
          punkt.setAttribute('aria-label', 'Seite ' + (i + 1) + ' von ' + seiten);
          punkt.dataset.seite = i;
          punkt.addEventListener('click', this.zuSeite.bind(this));
          this.punkteLeiste.appendChild(punkt);
        }
        this.punkteAktualisieren();
      }

      zuSeite(event) {
        var seite = parseInt(event.currentTarget.dataset.seite, 10) || 0;
        this.reihe.scrollTo({ left: seite * this.proSeite() * this.schritt(), behavior: 'smooth' });
      }

      punkteAktualisieren() {
        if (!this.punkteLeiste || !this.punkteLeiste.children.length) return;
        var breite = this.proSeite() * this.schritt();
        var aktuell = Math.round(this.reihe.scrollLeft / breite);
        var letzte = this.punkteLeiste.children.length - 1;
        // Am rechten Anschlag ist die letzte Seite erreicht, auch wenn die
        // Rechnung knapp darunter liegt.
        if (this.reihe.scrollLeft >= this.reihe.scrollWidth - this.reihe.clientWidth - 2) {
          aktuell = letzte;
        }
        Array.prototype.forEach.call(this.punkteLeiste.children, function (punkt, i) {
          punkt.setAttribute('aria-current', i === aktuell ? 'true' : 'false');
        });
      }

      /* Abstand von Kachelanfang zu Kachelanfang — inklusive Luecke. */
      schritt() {
        var karten = this.reihe.querySelectorAll('.nsc__item');
        if (karten.length < 2) return this.reihe.clientWidth;
        return karten[1].offsetLeft - karten[0].offsetLeft;
      }

      springe(richtung) {
        // So viele ganze Karten, wie sichtbar sind — mindestens eine.
        this.reihe.scrollBy({ left: richtung * this.proSeite() * this.schritt(), behavior: 'smooth' });
      }

      pfeile() {
        var rest = this.reihe.scrollWidth - this.reihe.clientWidth;
        var pos = this.reihe.scrollLeft;
        this.zurueck.disabled = pos <= 2;
        // Zwei Pixel Toleranz: Browser runden Scrollpositionen unterschiedlich.
        this.weiter.disabled = pos >= rest - 2;
      }
    }
  );
})();
